import React, { useState, useEffect, useRef } from "react";
import PlanTable from "../../components/ui/planTable/PlanTable";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import Developers from "../Developers/Developers";
import OurCustomers from "../ourCustomers/ourCustomers";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Core Swiper styles
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "swiper/css/navigation"; // Navigation module styles
import { Navigation } from "swiper/modules";
<img src="images/404.png" alt="Error Image" />;

const MainPage = () => {
  const [products, setProducts] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [virtualServers, setVirtualServers] = useState({ products: [] });
  const [searchLoading, setSearchLoading] = useState(false);
  const [faqCategories, setFaqCategories] = useState([]);
  const [expandedCategoryIndex, setExpandedCategoryIndex] = useState(0);
  const [expandedFaqIndex, setExpandedFaqIndex] = useState(null);
  const [toggleState, setToggleState] = useState(0);
  const swiperRef = useRef(null);

  // Fetch web hosting products
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://api.spadserver.com/api/product/economy-directadmin-hosting"
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        setProducts(result.data.products);
      } catch (error) {
        setError(`Error fetching data: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Fetch FAQ data
  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await fetch("https://api.spadserver.com/api/faqs");
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setFaqCategories(data.data); // Assuming `data.data` contains the FAQ categories
      } catch (error) {
        setError(`Error fetching FAQs: ${error.message}`);
      }
    };

    fetchFaqs();
  }, []);

  // Fetch virtual server products
  // Fetch virtual servers
  useEffect(() => {
    const fetchVirtualServers = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          "https://api.spadserver.com/api/product/virtual-server"
        );
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const result = await response.json();
        setVirtualServers(result.data);
      } catch (error) {
        setError(`Error fetching data: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchVirtualServers();
  }, []);

  // Settings for react-slick
  // Settings for react-slick
  const sliderSettings = {
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };
  const uniqueCategories = Array.from(
    new Map(
      virtualServers.products
        .filter(
          (product) =>
            product.service_category_id && product.service_category_name
        )
        .map((product) => [
          product.service_category_id,
          product.service_category_name,
        ])
    ).entries()
  );

  const currentCategoryId =
    uniqueCategories.length > 0 ? uniqueCategories[toggleState][0] : null;

  // Define filteredProducts based on the currentCategoryId
  const filteredProducts = currentCategoryId
    ? virtualServers.products.filter(
        (product) => product.service_category_id === currentCategoryId
      )
    : virtualServers.products;

  // Define uniqueProducts here
  const uniqueProducts = filteredProducts.filter(
    (product, index, self) =>
      index === self.findIndex((p) => p.title === product.title)
  );

  // Now calculate slidesToScroll after uniqueProducts is defined
  let slidesToScroll =
    uniqueProducts.length <= 4
      ? uniqueProducts.length - 1
      : uniqueProducts.length - 1;

  // Settings for the carousel
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: slidesToScroll,
    arrows: true,
    rtl: true,
    responsive: [
      {
        breakpoint: 1290,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          rtl: true,
        },
      },
    ],
  };
  // Handle search functionality
  const handleSearch = async (event) => {
    event.preventDefault();
    setSearchLoading(true);
    setShowSearchResults(true);

    try {
      const response = await fetch(
        `https://api.spadserver.com/api/domain-search?domain=${searchTerm}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data && Array.isArray(data.other)) {
        setSearchResults(data.other);
      } else {
        setSearchResults([]); // Clear previous results if none found
      }
    } catch (error) {
      setError(`Error fetching search results: ${error.message}`);
    } finally {
      setSearchLoading(false);
    }
  };

  if (!virtualServers) return <div>No data available</div>;

  const handleToggleSwitch = (index) => {
    setToggleState(index);
  };

  const toggleCategory = (index) => {
    setExpandedCategoryIndex(index);
    setExpandedFaqIndex(null); // Reset the FAQ within the category
  };

  const toggleFaq = (index) => {
    setExpandedFaqIndex(expandedFaqIndex === index ? null : index);
  };

  const stripTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center mt-8">
        <img src="images/404.png" alt="Error" className="w-64 h-auto mx-auto" />
        <p className="text-red-500 mt-4">{error}</p>
      </div>
    );
  }

  // Find the correct plans based on their titles in the new API response
  const plan1 = products.find(
    (product) => product.title === "پلن 1 هاست اقتصادی ایران"
  );
  const plan2 = products.find(
    (product) => product.title === "پلن 2 هاست اقتصادی ایران"
  );

  // Map static images to each FAQ category
  const categoryIcons = {
    "سرور مجازی": "/images/database.png",
    هاست: "/images/hosting.png",
    IP: "/images/ip.png",
  };

  return (
    <div className="">
      {/* Top Section with GIF and Hosting Plans */}
      <div className="flex flex-col md:flex-row gap-4 mb-8 main-container">
        <div className="p-4 rounded">
          <img
            src="images/servers.gif"
            alt="Server GIF"
            className="mb-4 md:w-[95rem] xl:w-[95rem] h-auto"
          />
        </div>
        {/* Swiper Carousel for Hosting Plans */}
        <div className="hosting-main w-[100%] mt-[2rem] md:mx-4 rounded">
          {/* Slider for mobile */}
          <div className="md:hidden">
            <Slider {...sliderSettings}>
              {plan1 && (
                <div>
                  <div className="p-2 rounded flex justify-center text-white">
                    <PlanTable products={[plan1]} />
                  </div>
                </div>
              )}
              {plan2 && (
                <div>
                  <div className="p-2 rounded flex justify-center text-white">
                    <PlanTable products={[plan2]} />
                  </div>
                </div>
              )}
            </Slider>
          </div>

          {/* Flexbox for desktop */}
          <div className="hidden md:flex md:space-x-4">
            {plan1 && (
              <div className="flex-1 p-2 rounded flex justify-center text-white">
                <PlanTable products={[plan1]} />
              </div>
            )}
            {plan2 && (
              <div className="flex-1 p-2 rounded flex justify-center text-white">
                <PlanTable products={[plan2]} />
              </div>
            )}
          </div>
          <div className="text-left mt-4 pl-[4rem]">
            <a
              href="product/economy-directadmin-hosting"
              className="text-white hover:underline border-b border-white"
              rel="noopener noreferrer"
            >
              مشاهده بیشتر
            </a>
          </div>
        </div>
      </div>

      {/* Domain Search Input */}
      <div
        className="p-4 sm:p-6 lg:p-10 mb-6 sm:mb-8 grid grid-cols-1 lg:grid-cols-2 gap-8 rounded-xl mt-10" // Increased gap from 4 to 8
        style={{ backgroundColor: "#2b324d" }}
      >
        <div className="flex flex-col">
          <div className="text-white text-lg sm:text-xl lg:text-2xl mb-4 text-right lg:text-right">
            بهترین نام دامنه را برای وب سایت خود پیدا کنید.
          </div>
          <div className="text-[12px] sm:text-[14px] text-white text-center lg:text-right mt-10 lg:hidden">
            آیا دامنه دارید؟{" "}
            <a
              href="https://crm.spadserver.com/cart.php?a=add&domain=transfer"
              className="text-white border-b border-white"
            >
              می‌توانید دامنه را انتقال دهید.
            </a>
            <div className=" border-gray-300 mt-2"></div>
          </div>
        </div>

        <form
          onSubmit={handleSearch}
          className="flex flex-col lg:flex-row gap-2 sm:gap-0 bg-white lg:rounded-[2rem] lg:p-1 rounded-[30px] p-5"
        >
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="نام دامنه‌ی خود را وارد کنید."
            className="p-2 pr-20 text-sm  text-black bg-white focus:outline-none focus:ring-0 rounded-md sm:rounded-none lg:rounded-r-[2rem] flex-1 w-full placeholder:text-gray-500 placeholder:opacity-70"
          />

          <button
            type="submit"
            className="search-button p-4 lg:ml-2 lg:my-2 text-black text-sm sm:text-base rounded-[20px] lg:rounded-r-[2rem] lg:rounded-l-[2rem] hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full lg:w-[160px]"
          >
            جستجو
          </button>
        </form>

        <div className="">
          <div className="text-[12px] sm:text-[14px] text-white text-center lg:text-right mt-10 lg:block hidden">
            آیا دامنه دارید؟{" "}
            <a
              href="https://crm.spadserver.com/cart.php?a=add&domain=transfer"
              className="text-white border-b border-white"
            >
              می‌توانید دامنه را انتقال دهید.
            </a>
            <div className=" border-gray-300 mt-2"></div>
          </div>
        </div>
        <div className="grid grid-cols-6">
          <div className="flex flex-col items-center">
            <div className="text-white lg:text-lg text-[10px] ">online.</div>
            <div className="text-white lg:text-lg text-[10px] lg:mt-2 mt-0">
              3.3 €
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-white lg:text-lg text-[10px]">net.</div>
            <div className="text-white lg:text-lg text-[10px] lg:mt-2 mt-0">
              17.5 €
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-white lg:text-lg text-[10px]">IR.</div>
            <div className="text-white lg:text-lg text-[10px] lg:mt-2 mt-0">
              40000 IRT
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-white lg:text-lg text-[10px]">info.</div>
            <div className="text-white lg:text-lg text-[10px] lg:mt-2 mt-0">
              4.3 €
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-white lg:text-lg text-[10px]">org.</div>
            <div className="text-white lg:text-lg text-[10px] lg:mt-2 mt-0">
              9.2 €
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-white lg:text-lg text-[10px]">com.</div>
            <div className="text-white lg:text-lg text-[10px] lg:mt-2 mt-0">
              14.2 €
            </div>
          </div>
        </div>
      </div>

      {/* Domain Search Results as Swiper */}
      {showSearchResults && (
        <div className="container p-4 rounded">
          {searchLoading ? (
            <div className="flex justify-center items-center">
              <LoadingSpinner />
            </div>
          ) : (
            <Swiper
              modules={[Navigation]}
              navigation={true}
              loop={true}
              spaceBetween={10}
              slidesPerView={1.25}
              centeredSlides={true}
              breakpoints={{
                640: {
                  slidesPerView: 1.5,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2.5,
                  spaceBetween: 10,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
              }}
            >
              {searchResults.length > 0 ? (
                searchResults.map((domain, index) => (
                  <SwiperSlide key={index}>
                    <div className="relative p-2 sm:p-4 border rounded-lg hover:bg-gray-600 transition duration-300 ease-in-out">
                      <div className="domain-content text-center">
                        <h2 className="domain-text-search text-lg sm:text-xl font-semibold mb-2 text-white hover:text-green-400">
                          دامنه {domain.tls}
                        </h2>
                        <div className="annually-search text-white mb-2">
                          (سالانه)
                        </div>
                        <div className="bottom-content flex flex-col sm:flex-row justify-between items-center">
                          <p
                            className={`mt-2 font-bold text-sm mb-4 ${
                              domain.isAvailable
                                ? "text-green-400"
                                : "text-red-400"
                            }`}
                          >
                            {domain.isAvailable ? "در دسترس" : "غیر قابل دسترس"}
                          </p>
                          {domain.isAvailable && (
                            <a
                              href={`https://crm.spadserver.com/cart.php?a=add&domain=${searchTerm}.${domain.tls}`}
                              className="purchase-button bg-black mt-4 block text-center py-2 px-4 rounded hover:bg-gray-800"
                            >
                              خرید دامنه
                            </a>
                          )}
                        </div>
                      </div>
                      <div className="domain-description mt-2 text-gray-300 text-sm">
                        <p>
                          Availability:{" "}
                          {domain.isAvailable ? "در دسترس" : "غیر قابل دسترس"}
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))
              ) : (
                <div className="text-white">نتیجه ای پیدا نشد.</div>
              )}
            </Swiper>
          )}
        </div>
      )}

      {/* Virtual Servers Section */}
      {/* Virtual Servers Section */}
      <div className="mb-8">
        <h2 className="text-2xl text-center text-white mb-4">سرویس های ویژه</h2>

        {/* Toggle Switches for Categories */}
        {uniqueCategories.length > 0 && (
          <div className="flex justify-center mt-6">
            <div className="bg-switch-full rounded-full p-2 flex space-x-1">
              {uniqueCategories.map((category, index) => (
                <button
                  key={category[0]}
                  className={`rounded-full px-4 py-2 w-[6rem] text-sm font-medium transition ${
                    toggleState === index
                      ? "bg-switch text-black"
                      : "bg-switch-off text-white"
                  }`}
                  onClick={() => handleToggleSwitch(index)}
                >
                  {category[1]}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="wrapper-swipp lg:p-[75px]">
          {/* Conditional rendering for React Slick or single centered product */}
          {uniqueProducts.length > 1 ? (
            <Slider {...settings}>
              {uniqueProducts.map((product, index) => (
                <div key={index} className="md:p-4 md:px-0 md:mx-0 p-12 mx-0">
                  <div className="plan-table-wrapper">
                    <PlanTable products={[product]} />
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            <div className="flex justify-center p-4">
              <div className="plan-table-wrapper">
                <PlanTable products={uniqueProducts} />
              </div>
            </div>
          )}
        </div>
        <div
          className="wrapper p-4 mt-4"
          style={{ backgroundColor: "#2b324d" }}
        >
          <div className="title-spad text-center text-white text-2xl font-bold mt-6">
            چرا اسپاد سرور را انتخاب می کنید؟
          </div>
          <div className="flex justify-center">
            <div className="text-center mt-12 text-white md:max-w-[46%] w-[100%]">
              ما از آخرین فن آوری سرورهای HP در بهترین دیتاسنترهای ایران و جهان
              استفاده می کنیم تا اطمینان حاصل کنیم که مشتریان ما بهترین عملکرد
              را از وب سایت های خود دریافت می کنند.
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-20">
            <div className="flex flex-col justify-center items-center rounded-full">
              <div className="main-icon text-white rounded-full p-2 w-16 h-16 flex justify-center items-center">
                <img
                  className="w-full h-full object-contain"
                  src="/images/stack-icon.png"
                  alt="Icon 1"
                />
              </div>
              <p className="mt-4 text-white">فناوری پایدار و ایمن</p>
            </div>
            <div className="flex flex-col justify-center items-center">
              <div className="main-icon text-white rounded-full p-2 w-16 h-16 flex justify-center items-center">
                <img
                  className="w-full h-full object-contain"
                  src="/images/headphone.png"
                  alt="Icon 2"
                />
              </div>

              <p className="mt-4 text-white">پشتیبانی 24 ساعته</p>
            </div>
            <div className="flex flex-col justify-center items-center">
              <div className="main-icon text-white rounded-full p-2 w-16 h-16 flex justify-center items-center">
                <img
                  className="w-full h-full object-contain"
                  src="/images/server-storage.png"
                  alt="Icon 3"
                />
              </div>
              <p className="mt-4 text-white">زیر ساخت اختصاصی</p>
            </div>
            <div className="flex flex-col justify-center items-center">
              <div className="main-icon text-white rounded-full p-2 w-16 h-16 flex justify-center items-center">
                <img
                  className="w-full h-full object-contain"
                  src="/images/star.png"
                  alt="Icon 4"
                />
              </div>

              <p className="mt-4 text-white">سرویس مهاجرت رایگان</p>
            </div>
          </div>
        </div>

        <div className="mainPageDevelopers mt-24 mb-14">
          <Developers />
        </div>
      </div>

      <div className="mainPageCustomers mb-4">
        <OurCustomers />
      </div>

      {/* FAQ Section */}
      <div
        className="mx-auto p-4 rounded-xl"
        style={{ backgroundColor: "rgba(128, 128, 128, 0.3)" }}
      >
        <div className="text-center text-white text-2xl font-bold py-4">
          سوالات شما
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
          {/* FAQ Categories */}
          <div className="sm:col-span-2 lg:col-span-1 flex flex-col space-y-4">
            {faqCategories.map((category, index) => (
              <div
                key={index}
                className="border p-4 rounded-[1.5rem] flex items-center space-x-4 cursor-pointer hover:bg-gray-600 transition duration-200"
                onClick={() => toggleCategory(index)}
              >
                <img
                  src={categoryIcons[category.title]}
                  alt={category.title}
                  className="w-12 h-12 object-contain"
                />
                <div className="text-white pr-8">
                  <h4 className="text-lg font-semibold">{category.title}</h4>
                  <p className="text-sm">{stripTags(category.description)}</p>
                </div>
              </div>
            ))}
          </div>

          {/* FAQs in Selected Category */}
          {faqCategories.length > 0 &&
            expandedCategoryIndex !== null &&
            faqCategories[expandedCategoryIndex] && (
              <div className="sm:col-span-2 lg:col-span-3 p-6 rounded-[1.5rem] flex flex-col space-y-4 border border-gray-500">
                {/* Display category title and description once */}
                <div className="flex items-center mb-4">
                  <img
                    src={
                      categoryIcons[faqCategories[expandedCategoryIndex].title]
                    } // Use the category icon for the expanded category
                    alt={faqCategories[expandedCategoryIndex].title} // Use the category title for alt text
                    className="w-12 h-12 object-contain mr-2"
                  />
                  <div className="text-white mr-4">
                    <h4 className="text-lg font-light">
                      {faqCategories[expandedCategoryIndex].title}
                    </h4>
                    <p className="text-[10px] mt-1">
                      {stripTags(
                        faqCategories[expandedCategoryIndex].description
                      )}
                    </p>
                  </div>
                </div>

                {/* Display FAQs under the selected category */}
                {faqCategories[expandedCategoryIndex].faqs.map((faq, index) => (
                  <div key={index}>
                    <h3
                      className="text-white font-light mb-2 lg:text-[14px] text-[11px] flex items-center cursor-pointer"
                      onClick={() => toggleFaq(index)}
                    >
                      <p className="">{faq.title}</p>
                      <span className="mr-2 text-sm">
                        {" "}
                        {/* Smaller size for the icons */}
                        {expandedFaqIndex === index ? "➖" : "➕"}
                      </span>
                    </h3>
                    {expandedFaqIndex === index && (
                      <p className="text-gray-300 font-light lg:text-[14px] text-[11px] mt-2 mb-2">
                        {stripTags(faq.description)}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default MainPage;
